import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { getPageTemplate } from 'components/agility-pageTemplates';
import { handlePreview } from '@agility/nextjs';
import { useRouter } from 'next/router';
import Custom404 from '../../pages/404';
import PreviewBar from './PreviewBar';
import SEO from './SEO';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import LoadingWidget from './LoadingWidget';
import { useAppInsightsTrackPageView } from 'appinsights/clientAppInsights';
import { SnackbarProvider } from 'notistack';

// set up handle preview
const isPreview = handlePreview();

function Layout(props) {
  const { page, sitemapNode, dynamicPageItem, notFound, pageTemplateName } =
    props;
  const [showPreview, setShowPreview] = useState(false);
  const addHeaderMarkup = dynamicPageItem?.seo?.metaHTML ?? page?.seo?.metaHTML;

  if (typeof window !== 'undefined') {
    useAppInsightsTrackPageView();
  }
  // Get page template name
  const AgilityPageTemplate = getPageTemplate(pageTemplateName);

  if (dynamicPageItem?.seo?.metaDescription) {
    page.seo.metaDescription = dynamicPageItem.seo.metaDescription;
  }

  const headerClick = (e) => {
    if (e.altKey) {
      setShowPreview(!showPreview);
    }
  };

  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  const router = useRouter();
  if (router.isFallback) {
    return <LoadingWidget message="Loading Page" />;
  }

  // if page not found, throw 404
  if (notFound === true) {
    return <Custom404 />;
  }

  return (
    <React.Fragment>
      <SEO
        title={sitemapNode?.title}
        description={page?.seo?.metaDescription}
        keywords={page?.seo?.metaKeywords}
        metaHTML={page?.seo?.metaHTML}
        additionalHeaderMarkup={addHeaderMarkup}
        path={sitemapNode?.path === '/home' ? '/' : sitemapNode?.path}
        noRobots={props.noRobots}
      />
      <SnackbarProvider>
        <div id="site-wrapper">
          {isPreview && <LoadingWidget message="Loading Preview Mode" />}
          {!isPreview && (
            <Container>
              {showPreview && <PreviewBar {...props} />}
              {/* <div style={{ overflow: 'hidden' }}> */}
              <div>
                <div className="flex flex-col min-h-screen">
                  <SiteHeader {...props} handleHeaderClick={headerClick} />
                  <main>
                    <AgilityPageTemplate {...props} />
                  </main>
                  {/* <FeaturedPost /> */}
                  <SiteFooter
                    {...props}
                    style={{ position: 'absolute', bottom: 0 }}
                  />
                </div>
              </div>
            </Container>
          )}
        </div>
      </SnackbarProvider>
    </React.Fragment>
  );
}

export default Layout;

const Container = styled('div')(({ theme: _theme }) => ({
  height: '100vh',
}));
